import { ShoppingBag, User, Menu, X } from "lucide-react";
import logoSvg from "@/assets/logo.svg";
import { useCartStore } from "@/stores/cartStore";
import { openShopifyAccount } from "@/stores/customerStore";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

export function Header() {
  const { openCart } = useCartStore();
  const itemCount = useCartStore((s) => s.items.reduce((sum, i) => sum + i.quantity, 0));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-3 sm:h-20 sm:px-4 md:px-6">
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="inline-flex text-foreground md:hidden"
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {mobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>

        <nav className="hidden items-center gap-6 md:flex xl:gap-8">
          <Link to="/product/oaria-hyaluronic-acid-hydration-serum-1-fl-oz" className="text-sm font-medium tracking-wide text-muted-foreground transition-colors hover:text-foreground">
            Shop
          </Link>
        </nav>

        <Link to="/product/oaria-hyaluronic-acid-hydration-serum-1-fl-oz" className="absolute left-1/2 -translate-x-1/2">
          <img src={logoSvg} alt="OARIA" className="h-14 sm:h-16" style={{ aspectRatio: '784.5/711.75' }} width={62} height={56} />
        </Link>

        <div className="ml-auto flex items-center gap-2 sm:gap-4">
          <button onClick={openShopifyAccount} className="hidden text-muted-foreground transition-colors hover:text-foreground lg:inline-flex" aria-label="Account">
            <User className="h-5 w-5" />
          </button>
          <button onClick={openCart} className="relative text-muted-foreground transition-colors hover:text-foreground" aria-label="Open cart">
            <ShoppingBag className="h-5 w-5" />
            {itemCount > 0 && (
              <motion.span
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="absolute -right-2 -top-2 flex h-[18px] w-[18px] items-center justify-center rounded-full bg-accent text-[10px] font-bold text-accent-foreground"
              >
                {itemCount}
              </motion.span>
            )}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden border-t border-border md:hidden"
          >
            <nav className="flex flex-col gap-1 px-4 py-3">
              <Link to="/product/oaria-hyaluronic-acid-hydration-serum-1-fl-oz" onClick={() => setMobileMenuOpen(false)} className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-secondary">
                Shop
              </Link>
              <div className="mt-2 flex flex-wrap items-center gap-4 border-t border-border px-3 pt-3">
                <button onClick={() => { setMobileMenuOpen(false); openShopifyAccount(); }} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <User className="h-4 w-4" /> Account
                </button>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
